import { combineReducers } from "redux";
import schoolReducers from "./schoolReducers";
import companyReducers from "./companyReducers";
export default combineReducers({
  YourSchool: schoolReducers,
  YourCompany: companyReducers,
});
